const CurrencyConfig = {
  collection: "currencies",
  fields: [
    "id",
    "symbol",
    "symbol_placement",
    "condition",
    "compare_against",
    "treat_empty_values_as",
    "applicable_templates.comparison_template_type_id"
  ],

  adapter: class Currency {
    constructor(currency) {
      const { applicable_templates, ...rest } = currency;
      Object.assign(this, {
        ...rest,
        applicable_templates: (applicable_templates || []).map(
          (t) => t.comparison_template_type_id
        )
      });
    }

    map(collections, maps) {
      this.applicable_templates = this.applicable_templates.map(
        (id) => maps.comparison_template_type[id]?.key || ""
      );
    }

    localizePriceAmount(price) {
      if (this.symbol_placement === "left") {
        return `${this.symbol}${price}`;
      }
      return `${price}${this.symbol}`;
    }
  }
};

export default CurrencyConfig;
